import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { getCustomer } from 'redux/customer/actions';
import { listLoyaltyTiers } from 'redux/loyaltyTiers/actions';
import { getProduct } from 'redux/products/actions';
import { getProductBySlug } from 'redux/products/reducers';

// eslint-disable-next-line import/no-cycle
import NoCustomer from './NoCustomer';
import Pricing from './Pricing';

const JordanRequestPricing = (props) => {
  const { slug } = props;

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getCustomer());
  }, [dispatch]);

  useEffect(() => {
    dispatch(listLoyaltyTiers());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getProduct(slug));
  }, [dispatch, slug]);

  const settings = useSelector((state) => state.setting.data);
  const customerReducer = useSelector((state) => state.customer);
  const loyaltyTierReducer = useSelector((state) => state.loyaltyTier);
  const product = useSelector((state) => getProductBySlug(state.product, slug));
  const { data: customer } = customerReducer;
  if (!settings) {
    return null;
  }
  if (customerReducer.isFetching || loyaltyTierReducer.isFetching) {
    return <div>Loading</div>;
  }
  if (!product) {
    return <div>Loading</div>;
  }
  return (
    <div className="widget-pricing">
      <Pricing product={product} customer={customer} />
      {!customer && <NoCustomer product={product} />}
    </div>
  );
};

export default JordanRequestPricing;
